import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CustomAlert from "../../components/Alert/CustomAlert";
import CustomDialog from "../../components/Dialog/CustomDialog";

const ALERT_TEXT_DEFAULT =
  "You are about to create a product in the database for all users. Make sure that the product is not already created and that the name is accurate.";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      textTransform: "uppercase",
    },
    marginBottom: {
      marginBottom: theme.spacing(4),
    },
  }),
);

interface ProductEditCreateDialogProps {
  alert?: JSX.Element;
  create?: boolean;
  open: boolean;
  title: string;
  handleClose: () => void;
  handleExited?: () => void;
}

function ProductEditCreateDialog(props: React.PropsWithChildren<ProductEditCreateDialogProps>) {
  const { alert, children, create, handleClose, handleExited, open, title } = props;
  const classes = useStyles();
  const header = `${create ? "create " : ""}${title}`;

  return (
    <CustomDialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      open={open}
      TransitionProps={{ onExited: handleExited }}
    >
      <h2 className={classes.header}>{header}</h2>
      {create && (alert || <CustomAlert className={classes.marginBottom} severity="info" text={ALERT_TEXT_DEFAULT} />)}
      {children}
    </CustomDialog>
  );
}

export default ProductEditCreateDialog;
